import React from 'react'
import "./About.css"

function About() {
    return (
        <section className="about-section">
            <div className="about-container">
                <div className="about-content">
                    <h1 className="about-title" dir="rtl">קהילת העסקים המקומית</h1>
                    <div className="about-text" dir="rtl">
                        <p>ברוכים הבאים לקהילת העסקים המקומית שלנו.</p>
                        <p>כאן תוכלו למצוא מגוון בתי עסק מקומיים,</p>
                        <p>ליהנות מהטבות ייחודיות ולתמוך בכלכלה המקומית.</p>
                        <p>הצטרפו אלינו לחוויית קנייה שתורמת לקהילה ומחזקת את העסקים בסביבה שלנו.</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About